import * as he from 'he';

function decodeSpecificHtmlEntities(str: string): string {
  return str
    .replace(/&#x27;/g, '’')
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/(^|[\s\(\[{<])"([^"]+)"(?=[\s\)\]}>,.!?;:]|$)/g, '$1“$2”')
    .replace(/(^|[\s\(\[{<])'([^']+)'(?=[\s\)\]}>,.!?;:]|$)/g, '$1‘$2’')
    .replace(/(\w)'(\w)/g, '$1’$2');
}

export function decodeHtmlEntities(html: string): string {
  if (!html) return '';

  try {
    if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined') {
      const parser = new DOMParser();
      const decoded = parser.parseFromString(html, 'text/html').documentElement.textContent;
      return decodeSpecificHtmlEntities(decoded || '') || decodeSpecificHtmlEntities(html);
    }
  } catch {
    // ignore and fall back
  }

  return he.decode(html);
}
